import React from 'react';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { FormGroup, Label } from 'reactstrap';
import { ButtonWithLoadingIcon } from '../../../common/ButtonWithLoadingIcon';
import { Colxx } from '../../../common/CustomBootstrap';
import '../profile.scss';
import { LinkButton } from '../../../common/LinkButton';
import '../../../common/custom-card-header/customCardheader.scss';
// components

const FormInputWrapper = ({
  label,
  id,
  showError,
  error,
  children,
  ...other
}) => {
  return (
    <FormGroup>
      <Label for={id} {...other} className={'label-text'}>
        {label}
      </Label>
      <div>
        {children}
        {showError && (
          <div className='invalid-feedback d-block label-text' style={{ fontFamily: 'Brown'}}>{error}</div>
        )}
      </div>
    </FormGroup>
  );
};

const CommonFormInput = ({ label, name, id, type, showError, error }) => (
  <FormInputWrapper label={label} id={id} showError={showError} error={error}>
    <Field
      type={type}
      name={name}
      id={id}
      className='form-control label-text'
    />
  </FormInputWrapper>
);

// end of components

const profileEditSchema = Yup.object().shape({
  first_name: Yup.string().required('Please enter the first name'),
  last_name: Yup.string().required('Please enter the last name'),

  email: Yup.string().required('Please enter the email'),
  phone: Yup.string().required('Please enter the phone'),

  // university: Yup.string().required('Please enter the university'),
});

export const ProfileEdit = ({
  profile,
  isUpdating,
  onSubmit,
  onClickCancel,
}) => {
  const initialValues = {
    first_name: profile.first_name || '',
    last_name: profile.last_name || '',
    email: profile?.email?.toLowerCase() || '',
    phone: profile.phone || '',
    // university: profile.university || '',
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={profileEditSchema}
    >
      {({ errors, touched }) => {
        return (
          <Form className='mb-4'>
            <FormGroup row>
              <Colxx sm={12}>
                <CommonFormInput
                  label='First Name'
                  type='text'
                  name='first_name'
                  id='profile-first-name'
                  showError={errors.first_name && touched.first_name}
                  error={errors.first_name}
                />
              </Colxx>

              <Colxx sm={12}>
                <CommonFormInput
                  label='Last Name'
                  type='text'
                  name='last_name'
                  id='profile-last-name'
                  showError={errors.last_name && touched.last_name}
                  error={errors.last_name}
                />
              </Colxx>

              <Colxx sm={12}>
                <CommonFormInput
                  label='Email'
                  type='text'
                  name='email'
                  id='profile-email'
                  showError={errors.email && touched.email}
                  error={errors.email}
                />
              </Colxx>

              <Colxx sm={12}>
                <CommonFormInput
                  label='Phone'
                  type='text'
                  name='phone'
                  id='profile-phone'
                  showError={errors.phone && touched.phone}
                  error={errors.phone}
                />
              </Colxx>

              {/* <Colxx sm={12}>
                <CommonFormInput
                  label='University'
                  type='text'
                  name='university'
                  id='profile-university'
                  showError={errors.university && touched.university}
                  error={errors.university}
                />
              </Colxx> */}
            </FormGroup>

            <FormGroup row>
              <Colxx
                sm={12}
                className='d-flex justify-content-center align-items-center flex-direction-column'
                style={{ flexDirection: 'column' }}
              >
                <ButtonWithLoadingIcon
                  disabled={isUpdating}
                  type='submit'
                  loading={isUpdating}
                  color='primary'
                  size='md'
                  height={36}
                >
                  UPDATE
                </ButtonWithLoadingIcon>
                <LinkButton
                  className={'mt-3'}
                  onClick={() => {
                    if (onClickCancel) {
                      onClickCancel();
                    }
                  }}
                >
                  <span className='actionLabelText'>Cancel</span>
                </LinkButton>
              </Colxx>
            </FormGroup>
          </Form>
        );
      }}
    </Formik>
  );
};
